import * as React from "react";

// Classes
import Questionaire from "../domain/classes/Questionaire";
import IPatientDetails from "../domain/interfaces/IPatientDetails";

// Interfaces
import IQuestion from "../domain/interfaces/IQuestion";

// Utility
import PatientAttributesQuestions from "../domain/utility/questions";

export const InitialPatientDetailsQuestion: IQuestion<IPatientDetails> = {
	id: "",
	question: "",
	options: [],
	prevId: null,
	key: null,
};

export interface IQuestionaireContext<T extends {}> {
	currentQuestion: IQuestion<T>;
	handleCurrentQuestionChange: (value: IQuestion<T>) => void;
}

export const QuestionaireContext = React.createContext<
	IQuestionaireContext<IPatientDetails>
>({
	currentQuestion: InitialPatientDetailsQuestion,
	handleCurrentQuestionChange: (value: IQuestion<IPatientDetails>) => {},
});

export interface QuestionaireManagerProps {}

const QuestionaireManager: React.FC<QuestionaireManagerProps> = ({
	children,
}) => {
	// States
	const [currentQuestion, setCurrentQuestion] = React.useState<
		IQuestion<IPatientDetails>
	>(InitialPatientDetailsQuestion);

	// Effects
	React.useEffect(() => {
		const questionaire = new Questionaire(PatientAttributesQuestions);
		setCurrentQuestion(questionaire.getEntry());
	}, []);

	// Handlers
	const handleCurrentQuestionChange = (value: IQuestion<IPatientDetails>) => {
		setCurrentQuestion(value);
	};

	return (
		<QuestionaireContext.Provider
			value={{ currentQuestion, handleCurrentQuestionChange }}
		>
			{children}
		</QuestionaireContext.Provider>
	);
};

export const useQuestionaireManager = () =>
	React.useContext(QuestionaireContext);

export default QuestionaireManager;
